import { getActionTypes } from '../../../../HelperMethods/UtilityFunctions';

const types = getActionTypes('watcherGroupManagement')([
  'SET_LOADER',
  'LOAD_WATCHER_GROUPS',
  'UPSERT_WATCHER_GROUP',
  'DELETE_WATCHER_GROUP',
  'SET_FORM_LOADER',
]);
export function loadWatcherGroups(watchergroups) {
  return { type: types.LOAD_WATCHER_GROUPS, watchergroups };
}

export function setLoader(loader) {
  return { type: types.SET_LOADER, loader };
}

export function setFormLoader(loader) {
  return { type: types.SET_FORM_LOADER, loader };
}

export function upsertWatcherGroup(watchergroup) {
  return { type: types.UPSERT_WATCHER_GROUP, watchergroup };
}

export function deleteWatcherGroup(watchergroup) {
  return { type: types.DELETE_WATCHER_GROUP, watchergroupId: watchergroup.id };
}

export default function wacherGroupReducer(
  state = { isWatcherGroupPageLoading: true, watchergroups: [], isWatcherGroupFormLoading: false },
  action
) {
  switch (action.type) {
    case types.SET_LOADER: {
      return { ...state, isWatcherGroupPageLoading: action.loader };
    }
    case types.SET_FORM_LOADER: {
      return { ...state, isWatcherGroupFormLoading: action.loader };
    }
    case types.LOAD_WATCHER_GROUPS: {
      return { ...state, watchergroups: action.watchergroups };
    }
    case types.DELETE_WATCHER_GROUP: {
      return {
        ...state,
        watchergroups: state.watchergroups.filter(({ id }) => id !== action.watchergroupId),
      };
    }
    case types.UPSERT_WATCHER_GROUP: {
      const { watchergroup } = action;
      return {
        ...state,
        watchergroups: [...state.watchergroups.filter(({ id }) => id !== watchergroup.id), watchergroup],
      };
    }
    default:
      return state;
  }
}
